import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  serverTimestamp,
  setDoc,
  Unsubscribe,
} from "firebase/firestore";
import { Pick, Pickem } from "model/Pickem/Pickem";
import { store } from "app/store";
import { updatePickem } from "app/slices/UserSlice";
import { db } from "firebase-config";
import { mapPickem } from "db/mapping/pickem/FsPickem";
import { FsPickem } from "db/model/pickem/FsPickem";
import {
  userPicksCollectionName,
  pickemDetailsCollectionName,
} from "./collectionNames";
import { nonUndefined } from "Utility";
import { mapTournamentPickemDetails } from "db/mapping/pickemDetails/FsTournamentPickemDetails";
import { FsTournamentPickemDetails } from "db/model/pickemDetails/FsTournamentPickemDetails";
import { updatePickemDetails } from "app/slices/PickemDetailsSlice";

export const pickemSubscriptions: { [key: string]: Unsubscribe } = {};

export const setupPickemDetailsSnapshot = () => {
  onSnapshot(collection(db, pickemDetailsCollectionName), (querySnapshot) => {
    const pickemDetails = nonUndefined(
      querySnapshot
        .docChanges()
        .map((d) =>
          mapTournamentPickemDetails(
            d.doc.data() as FsTournamentPickemDetails,
            d.doc.id
          )
        )
    );

    store.dispatch(
      updatePickemDetails({
        pickemDetails,
      })
    );
  });
};

export const savePicksToDatabase = async (
  uid: string,
  tournamentId: string,
  pickemId: string,
  picks: { [id: string]: Pick },
  driverPicks: (string | undefined)[] | undefined
) => {
  const pickemUserDocRef = doc(db, userPicksCollectionName, uid);
  // Create pickemUser parent document if needed
  if (!(await getDoc(pickemUserDocRef)).exists()) {
    await setDoc(pickemUserDocRef, {});
  }

  const pickemDocRef = doc(
    db,
    userPicksCollectionName,
    uid,
    tournamentId,
    pickemId
  );
  await setDoc(pickemDocRef, {
    driverPicks,
    picks,
    lastEdited: serverTimestamp(),
  });
};

export const fetchPickems = (uid: string, tournamentId: string) => {
  const unsubscribe = onSnapshot(
    collection(db, userPicksCollectionName, uid, tournamentId),
    (querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        store.dispatch(
          updatePickem({
            id: getPickemKey(tournamentId, change.doc.id),
            data: change.doc.data() as FsPickem,
          })
        );
      });
    }
  );

  pickemSubscriptions[userPicksCollectionName] = unsubscribe;
};

export const getUserPickems = async (
  uid: string,
  tournamentId: string,
  pickemIdsToGet: string[]
) => {
  const pickemSnapshot = await getDocs(
    collection(db, userPicksCollectionName, uid, tournamentId)
  );
  const userPickems: { [pickemId: string]: Pickem } = {};
  pickemSnapshot.forEach((doc) => {
    if (pickemIdsToGet.includes(doc.id)) {
      const pickem = mapPickem(doc.data() as FsPickem);
      if (pickem) {
        userPickems[doc.id] = pickem;
      }
    }
  });

  return userPickems;
};

export const getPickemKey = (tournamentId: string, pickemId: string) => {
  return `${tournamentId}${pickemId}`;
};
